import { render, staticRenderFns } from "./wine-sales.vue?vue&type=template&id=418914f8&scoped=true&"
import script from "./wine-sales.vue?vue&type=script&lang=js&"
export * from "./wine-sales.vue?vue&type=script&lang=js&"
import style0 from "./wine-sales.vue?vue&type=style&index=0&id=418914f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418914f8",
  null
  
)

export default component.exports